<template>
  <div id="requestall">
    <div name="hrms-index-search-requestall" class="box border-top-color-skin" id="index-search-requestall">
      <div class="box-body">
        <div class="row">

          <div class="col-xs-6 col-md-3 input-half-left">
            <div class="form-group">
              <label>{{indexSearchLabels[dash.nowLang].datemax}} :</label>
              <hrms-datepicker v-model="indexSearch.p_datemax" 
                              :error="errDatemax != ''" />
            </div>
          </div>

          <div class="col-xs-6 col-md-3 input-half-right">
            <div class="form-group">
              <label>{{indexSearchLabels[dash.nowLang].datemin}} :</label>
              <hrms-datepicker v-model="indexSearch.p_datemin" 
                              :error="errDatemin != ''" />
            </div>
          </div> 

          <div class="col-xs-6 col-md-3 input-half-left">
            <div class="form-group">
              <label>{{indexSearchLabels[dash.nowLang].staappr}} :</label>
              <hrms-dropdown v-model="indexSearch.p_staappr" :options="dropdowns.p_staappr[dash.nowLang]" />
            </div>
          </div>

          <div class="col-xs-6 col-md-3 input-half-left">
            <div class="form-group">
              <label>{{indexSearchLabels[dash.nowLang].codapp}} :</label>
              <hrms-dropdown v-model="indexSearch.p_codapp" :options="dropdowns.p_codapp[dash.nowLang]" />
            </div>
          </div>

          <div class="col-xs-12 col-md-6">
            <div class="form-group-button">
              <div class="btn button-in-search bg-dark-gray" @click="clearSearchParams()"><i class="fa fa-refresh"></i>{{indexSearchLabels[dash.nowLang].btnClear}}</div>
              <div class="btn button-in-search bg-color-skin" @click="callSearch(indexSearch)"><i class="fa fa-search"></i>{{indexSearchLabels[dash.nowLang].btnSearch}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <hrms-table :columns="columns[dash.nowLang].index" 
                :data="index"
                :indexDisp="true"
                :detailEvent="detailEvent"
                :approveBtnDisp="true"
                :approveDisp="true" />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as types from 'store/modules/requestall/mutation-types'
import moment from 'moment'
import { router } from 'src/router'
import swal from 'sweetalert'
import labels from 'src/../config/label'

export default {
  name: 'requestall',
  data () {
    return {
      indexSearchLabels: {
        en: {
          datemax: 'Last Date',
          datemin: 'Previous Date',
          staappr: 'Approve Status',
          codapp: 'Application Request',
          btnClear: 'Clear',
          btnSearch: 'Search'
        },
        th: {
          datemax: 'วันที่ล่าสุด',
          datemin: 'ย้อนหลังถึงวันที่',
          staappr: 'สถานะการอนุมัติ',
          codapp: 'ฟังก์ชันการบันทึก',
          btnClear: 'ล้างค่า',
          btnSearch: 'ค้นหา'
        }
      },
      valid: true,
      errDatemin: '',
      errDatemax: '',
      errDate: '',
      indexSearch: {
        p_datemax: '',
        p_datemin: '',
        p_staappr: 'P',
        p_codapp: 'ALL'
      },
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY')
    }
  },
  watch: {
    'indexSearch.p_datemin' () {
      this.valid = this.validateDateSearch(this.indexSearch.p_datemax, this.indexSearch.p_datemin)
      this.errDatemin = ''
      this.errDatemax = ''
      this.errDate = ''
      if (!this.valid) {
        this.errDatemin = 'Previous Date should not be more than Last Date'
        this.errDate = this.errDatemin
      }
    },
    'indexSearch.p_datemax' () {
      this.valid = this.validateDateSearch(this.indexSearch.p_datemax, this.indexSearch.p_datemin)
      this.errDatemin = ''
      this.errDatemax = ''
      this.errDate = ''
      if (!this.valid) {
        this.errDatemax = 'Last Date should not be less than Previous Date'
        this.errDate = this.errDatemax
      }
    }
  },
  created () {
    this.receivedRequestallColumnsLabels()
    this.receivedRequestallIndex()
    this.receivedRequestallDropdowns()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_REQUESTALL_INDEX_DISP,
      columns: types.GET_REQUESTALL_COLUMNS,
      labels: types.GET_REQUESTALL_LABELS,
      index: types.GET_REQUESTALL_INDEX,
      indexSelected: types.GET_REQUESTALL_INDEX_SELECTED,
      dropdowns: types.GET_REQUESTALL_DROPDOWNS
    })
  },
  props: {
    nowLang: {
      type: String,
      default: labels.defaultLang
    }
  },
  methods: {
    callSearch (indexSearch) {
      this.valid = this.validateDateSearch(indexSearch.p_datemax, indexSearch.p_datemin)
      if (this.valid) {
        this.receivedRequestallIndex(indexSearch)
      } else {
        swal({
          title: 'Cannot Search',
          text: this.errDate
        })
      }
    },
    validateDateSearch (datemax, datemin) {
      if (datemax !== '' && datemin !== '') {
        let datemaxReplace = datemax.replace(/\//g, '')
        let datemaxConverted = datemaxReplace.substring(4, 8) + '-' + datemaxReplace.substring(2, 4) + '-' + datemaxReplace.substring(0, 2)
        let dateminReplace = datemin.replace(/\//g, '')
        let dateminConverted = dateminReplace.substring(4, 8) + '-' + dateminReplace.substring(2, 4) + '-' + dateminReplace.substring(0, 2)
        if (new Date(datemaxConverted) >= new Date(dateminConverted)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    clearSearchParams () {
      this.indexSearch.p_datemax = ''
      this.indexSearch.p_datemin = ''
      this.indexSearch.p_staappr = 'P'
      this.indexSearch.p_codapp = 'ALL'
    },
    detailEvent (param) {
      router.push({ name: 'hres62e' })
    },
    ...mapActions({
      toggle: types.TOGGLE_REQUESTALL_PAGE,
      receivedRequestallColumnsLabels: types.RECEIVED_REQUESTALL_COLUMNS_LABELS,
      receivedRequestallIndex: types.RECEIVED_REQUESTALL_INDEX,
      receivedRequestallDropdowns: types.RECEIVED_REQUESTALL_DROPDOWNS
    })
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?61a6ab02